import aboutImage from "../assets/img/Team_collaboration_about_section_24369981.png";

export default function About() {
  return (
    <section className="py-16 md:py-24 bg-white" data-testid="section-about">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Text Content */}
          <div className="space-y-6">
            <h2 className="text-3xl md:text-4xl font-heading font-semibold text-[#033644] mb-4">
              Sobre Nosotros
            </h2>
            <p className="text-base md:text-lg text-gray-700 leading-relaxed">
              Technova es una compañía joven con visión, dedicada a ofrecer{" "}
              <span className="font-medium text-[#033644]">
                soluciones tecnológicas a medida
              </span>{" "}
              para empresas en Guinea Ecuatorial y más allá.
            </p>
            <p className="text-base md:text-lg text-gray-700 leading-relaxed">
              Nuestra misión es transformar los desafíos tecnológicos de
              nuestros clientes en oportunidades de crecimiento, proporcionando
              servicios de alta calidad en consultoría, formación,
              infraestructura de redes y seguridad informática.
            </p>
            <p className="text-base md:text-lg text-gray-700 leading-relaxed">
              Nos distinguimos por nuestro{" "}
              <span className="font-medium text-[#033644]">
                compromiso con la excelencia
              </span>
              , la innovación constante y un profundo entendimiento de las
              necesidades específicas del mercado local.
            </p>
          </div>

          {/* Image */}
          <div className="lg:order-first">
            <img
              src={aboutImage}
              alt="Equipo Technova colaborando"
              className="w-full h-auto rounded-2xl shadow-lg"
              data-testid="img-about-team"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
